/* =============================================================================
=    Query User
============================================================================= */
import gql from 'graphql-tag';

export default gql`
query user {
  user {
    id
    firstName
    lastName
    emailSubscription
    mobile
    addressCode
    email
  }
}
`;
